import { EuiSkeletonText } from "@elastic/eui";

const SkeletonPlaceholder = ({
  isLoading,
  lines = 3,
}: {
  isLoading: boolean;
  lines?: 3 | 4 | 10 | 1 | 2 | 5 | 6 | 7 | 8 | 9 | undefined;
}) => {
  return (
    <EuiSkeletonText
      size="relative"
      lines={lines}
      isLoading={isLoading}
      contentAriaLabel="Demo skeleton title"
    />
  );
};

export default SkeletonPlaceholder;
